import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup, Stack,
  TextField, Typography,
} from '@mui/material';
import { AuthContext } from 'constants/contexts';
import useConfig from 'hooks/useConfig';
import React, { useContext, useEffect } from 'react';

import PhoneInput from 'react-phone-input-2';

function DeliveryForm({
  receiver, setReceiver, recipient, setRecipient,
}) {
  const defaultAreaCode = useConfig('general.defaultAreaCode', 'ca');
  const { user } = useContext(AuthContext);
  useEffect(() => {
    if (recipient?.name) {
      setReceiver('other');
    }
  }, [recipient]);
  const onChangeReceiver = (e) => {
    setReceiver(e.target.value);
    if (e.target.value === 'me') {
      onChangeRecipient(null);
    }
  };
  const onChangeRecipient = (value) => {
    setRecipient(value);
  };

  return (
    <Box>
      <RadioGroup
        name="select-receiver"
        value={receiver}
        onChange={onChangeReceiver}
      >
        <OptionContainer isSelected={receiver === 'me'}>
          <FormControlLabel
            value="me"
            control={<Radio />}
            sx={{ '& .MuiFormControlLabel-label': { width: '100%' } }}
            label={(
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="label-md" fontWeight={700}>Me</Typography>
                {user?.name && (
                  <Typography variant="body-caption" color="text.secondary">
                    {user.name}
                    {' '}
                    ·
                    {' '}
                    {user?.phone}
                  </Typography>
                )}
              </Stack>
            )}
          />
        </OptionContainer>

        <OptionContainer isSelected={receiver === 'other'}>
          <FormControlLabel
            value="other"
            control={<Radio />}
            label={(
              <Typography variant="label-md" fontWeight={700}>Someone else</Typography>
            )}
          />
          {receiver === 'other' && (
            <Stack spacing={1} my={2}>
              <Stack direction="row" spacing={1} width="100%">
                <TextField
                  value={recipient?.name || ''}
                  onChange={(e) => {
                    e.preventDefault();
                    onChangeRecipient({ ...recipient, name: e.target.value });
                  }}
                  label="First name"
                  sx={{ backgroundColor: 'background.default', borderRadius: 3 }}
                  fullWidth
                  data-testid="receiver-first-name"
                />
                <TextField
                  value={recipient?.lastname || ''}
                  onChange={(e) => onChangeRecipient({ ...recipient, lastname: e.target.value })}
                  label="Last name"
                  sx={{ backgroundColor: 'background.default', borderRadius: 3 }}
                  fullWidth
                  data-testid="receiver-last-name"
                />
              </Stack>
              <PhoneInput
                country={defaultAreaCode}
                buttonClass="phone-country"
                value={recipient?.phone}
                inputClass="input"
                onChange={(value, country) => {
                  onChangeRecipient({ ...recipient, phone: value });
                }}
                placeholder="Enter phone number"
                autofocus
                preferredCountries={['us', 'ca']}
                inputStyle={{
                  width: '100%',
                  height: 48,
                  borderRadius: 12,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '0px',
                  fontWeight: 700,
                }}
                buttonStyle={{ borderRadius: '12px 0 0 12px' }}
                enableSearch
                regions={['america', 'europe']}
                countryCodeEditable={false}
                masks={{
                  pr: '(...) ...-....',
                }}
                inputProps={{
                  'data-testid': 'receiver-phone',
                }}
              />
            </Stack>
          )}
        </OptionContainer>
      </RadioGroup>
    </Box>
  );
}
function OptionContainer({ isSelected, children }) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'border.default',
        borderRadius: 3,
        px: 1,
        backgroundColor: isSelected ? 'background.elevation1' : 'inherit',
        mb: 2,
        '& label': { width: '100%', mb: 0, mr: 0 },
      }}
    >
      {children}
    </Box>
  );
}
export default DeliveryForm;
